import { Calendar, Repeat, Target, Users } from "lucide-react"

export const GROUP_TYPES = {
  CHAMAA: "CHAMAA",
  SAVINGS: "SAVINGS",
  WELFARE: "WELFARE",
  NON_RECURRING: "NON_RECURRING",
  OTHER: "OTHER",
}

export const getGroupType = (group) => {
  if (group?.isChamaa) return GROUP_TYPES.CHAMAA
  if (group?.isProjectSavings) return GROUP_TYPES.SAVINGS
  if (group?.isWelfare || group?.eventType?.toLowerCase().includes("welfare") || group?.eventType?.toLowerCase().includes("support")) return GROUP_TYPES.WELFARE
  if (group?.category === "non-recurring") return GROUP_TYPES.NON_RECURRING
  return GROUP_TYPES.OTHER
}

export const GROUP_THEMES = {
  [GROUP_TYPES.CHAMAA]: {
    primary: "emerald-500",
    bg: "bg-[#53F587]/10",
    text: "text-emerald-700",
    border: "border-emerald-200",
    iconBg: "bg-[#53F587]",
    badge: "bg-[#53F587]/20 text-emerald-800 border-emerald-300",
    label: "Chamaa",
    icon: Repeat,
    mutedBg: "bg-[#53F587]/5",
    mutedText: "text-emerald-900/70",
    accentText: "text-emerald-900",
    progressBg: "bg-emerald-100",
    progressFill: "bg-[#53F587]",
    activeTab: "bg-[#53F587] text-emerald-900",
    cardBg: "bg-[#53F587]/5",
    detailsBg: "bg-[#53F587]/5",
    borderLeft: "border-l-[#53F587]",
    ring: "focus:ring-[#53F587]",
    button: "bg-[#53F587] hover:bg-[#42e476] text-emerald-900",
    bgMuted50: "bg-[#53F587]/5",
  },
  [GROUP_TYPES.SAVINGS]: {
    primary: "sky-500",
    bg: "bg-[#B3EFFF]",
    text: "text-sky-700",
    border: "border-sky-300",
    iconBg: "bg-sky-400",
    badge: "bg-[#B3EFFF] text-sky-800 border-sky-300",
    label: "Savings",
    icon: Target,
    mutedBg: "bg-[#B3EFFF]/60",
    mutedText: "text-sky-800/70",
    accentText: "text-sky-900",
    progressBg: "bg-sky-200",
    progressFill: "bg-sky-500",
    activeTab: "bg-sky-500 text-white",
    cardBg: "bg-[#B3EFFF]/50",
    detailsBg: "bg-[#B3EFFF]/25",
    borderLeft: "border-l-sky-400",
    ring: "focus:ring-sky-400",
    button: "bg-sky-500 hover:bg-sky-600 text-white",
    bgMuted50: "bg-[#B3EFFF]/60",
  },
  [GROUP_TYPES.WELFARE]: {
    primary: "[#454141]",
    bg: "bg-[#454141]/10",
    text: "text-[#454141]",
    border: "border-[#454141]/20",
    iconBg: "bg-[#454141]",
    badge: "bg-[#454141]/20 text-[#454141] border-[#454141]/30",
    label: "Welfare",
    icon: Users,
    mutedBg: "bg-[#454141]/5",
    mutedText: "text-[#454141]/70",
    accentText: "text-[#454141]",
    progressBg: "bg-[#454141]/10",
    progressFill: "bg-[#454141]",
    activeTab: "bg-[#454141] text-white",
    cardBg: "bg-[#454141]/10",
    detailsBg: "bg-[#454141]/5",
    borderLeft: "border-l-[#454141]",
    ring: "focus:ring-[#454141]",
    button: "bg-[#454141] hover:bg-[#373434] text-white",
    bgMuted50: "bg-[#454141]/5",
  },
  [GROUP_TYPES.NON_RECURRING]: {
    primary: "[#E07B39]",
    bg: "bg-[#E07B39]/10",
    text: "text-[#7C3D12]",
    border: "border-[#E07B39]/30",
    iconBg: "bg-[#E07B39]",
    badge: "bg-[#E07B39]/15 text-[#7C3D12] border-[#E07B39]/30",
    label: "Event",
    icon: Calendar,
    mutedBg: "bg-[#FFF5E9]",
    mutedText: "text-[#7C3D12]/70",
    accentText: "text-[#7C3D12]",
    progressBg: "bg-[#E07B39]/15",
    progressFill: "bg-[#E07B39]",
    activeTab: "bg-[#E07B39] text-white",
    cardBg: "bg-[#FFF5E9]",
    detailsBg: "bg-[#FFF5E9]/80",
    borderLeft: "border-l-[#E07B39]",
    ring: "focus:ring-[#E07B39]",
    button: "bg-[#E07B39] hover:bg-[#C96A2A] text-white",
    bgMuted50: "bg-[#FFF5E9]/70",
  },
  [GROUP_TYPES.OTHER]: {
    primary: "sky-600",
    bg: "bg-sky-100",
    text: "text-sky-700",
    border: "border-sky-200",
    iconBg: "bg-sky-500",
    badge: "bg-sky-200 text-sky-800 border-sky-300",
    label: "Group",
    icon: Users,
    mutedBg: "bg-sky-100/60",
    mutedText: "text-sky-900/70",
    accentText: "text-sky-900",
    progressBg: "bg-sky-200",
    progressFill: "bg-sky-500",
    activeTab: "bg-sky-600 text-white",
    cardBg: "bg-sky-100/60",
    detailsBg: "bg-sky-100/30",
    borderLeft: "border-l-sky-600",
    ring: "focus:ring-sky-600",
    button: "bg-sky-600 hover:bg-sky-700 text-white",
    bgMuted50: "bg-sky-100/50",
  },
}

export const getGroupTheme = (group) => {
  const type = getGroupType(group)
  return GROUP_THEMES[type] || GROUP_THEMES[GROUP_TYPES.OTHER]
}
